import Vue from 'vue';
// import App from './App.vue';
import VueRouter, { RouteConfig } from 'vue-router';
import RouterTab from './RouterTab.vue'
import VoteModule from './VoteModule.vue'
import PosterModule from './PosterModule.vue'
import Jump from './jump.vue';
import vConsole from 'vconsole'
import PortalVue from 'portal-vue';

// Vue.use(PortalVue);
Vue.config.productionTip = false;

// const VC = vConsole
// new VC()


// new Vue({
//   render: h => h(VoteModule, {
//     props: {
//       type: 'h5'
//     }
//   }),
// }).$mount('#M51jmYpHsrb')

// new Vue({
//   render: h => h(PosterModule, {
//     props: {
//       type: 'h5'
//     }
//   }),
// }).$mount('#MBrr79ehUcn')
new Vue({
  render: h => h(VoteModule, {
    props: {
      type: 'h5'
    }
  }),
}).$mount('#MWdKwhegUCM')

new Vue({
  render: h => h(PosterModule, {
    props: {
      type: 'h5'
    }
  }),
}).$mount('#MuJrMdFV1jZ')

